var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVilla(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add_Villa",
    "data-name": "Add Villa",
    transform: "translate(-8 -8.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62740",
    "data-name": "Group 62740",
    transform: "translate(9.194 9.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M66.129,342.677v-16.71H55.387v16.71H47.032v-19.1h1.194V320H24.355v3.581h1.194v19.1H16v3.581H87.613v-3.581Z",
    transform: "translate(-16 -274.645)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M32,240H98.839v3.581H32Z",
    transform: "translate(-29.613 -206.581)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M376,360h9.548v8.355H376Z",
    transform: "translate(-322.29 -308.677)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M376,120h9.548v8.355H376Z",
    transform: "translate(-322.29 -104.484)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M280,120h9.548v8.355H280Z",
    transform: "translate(-240.613 -104.484)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M240.355,25.474l10.742-4.7,10.742,4.7,4.774,2.089,3.581,1.567V24.355L251.1,16,232,24.355v4.774l3.581-1.567Z",
    transform: "translate(-199.774 -16)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M32,160H65.419v3.581H32Z",
    transform: "translate(-29.613 -138.516)",
    fill: "#90d8ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62741",
    "data-name": "Group 62741",
    transform: "translate(8 8.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M80.806,76.034H77.226V47.389h1.194A1.194,1.194,0,0,0,79.613,46.2V42.615a1.194,1.194,0,0,0-1.194-1.194H77.226V22.583l1.908.835a1.194,1.194,0,0,0,1.672-1.094V17.55a1.194,1.194,0,0,0-.715-1.094L61,8.1a1.2,1.2,0,0,0-.958,0l-19.1,8.355a1.194,1.194,0,0,0-.715,1.094v4.774A1.194,1.194,0,0,0,41.9,23.418l1.908-.835v6.9H11.581a1.194,1.194,0,0,0-1.194,1.194V34.26a1.194,1.194,0,0,0,1.194,1.194h3.581v5.968H11.581a1.194,1.194,0,0,0-1.194,1.194V46.2a1.194,1.194,0,0,0,1.194,1.194h1.194V76.034H9.194A1.194,1.194,0,0,0,8,77.228v3.581A1.194,1.194,0,0,0,9.194,82H80.806A1.194,1.194,0,0,0,82,80.809V77.228A1.194,1.194,0,0,0,80.806,76.034ZM42.613,20.5V18.331l17.9-7.833,17.9,7.833V20.5L76.5,19.66l-.006,0L61,12.876a1.2,1.2,0,0,0-.958,0l-15.5,6.781-.006,0Zm32.226,1.038V41.421H46.194V21.538l14.323-6.266ZM12.774,33.067V31.873H43.806v1.194Zm31.032,2.387v5.968H39.032V35.454Zm-7.161,0v5.968H31.871V35.454Zm-7.161,0v5.968H24.71V35.454Zm-7.161,0v5.968H17.548V35.454Zm-9.548,8.355H77.226V45H12.774ZM59.323,59.325H48.581a1.194,1.194,0,0,0-1.194,1.194V76.034H46.194V47.389H74.839V76.034H60.516V60.518A1.194,1.194,0,0,0,59.323,59.325Zm-1.194,2.387V76.034H49.774V61.712Zm-16.71-8.355H17.548a1.194,1.194,0,0,0-1.194,1.194v3.581a1.194,1.194,0,0,0,1.194,1.194v16.71H15.161V47.389H43.806V76.034H41.419V59.325a1.194,1.194,0,0,0,1.194-1.194V54.55A1.194,1.194,0,0,0,41.419,53.357ZM18.742,56.938V55.744H40.226v1.194Zm20.29,2.387v16.71h-19.1V59.325Zm40.581,20.29H10.387V78.421H79.613Z",
    transform: "translate(-8 -8.002)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M369.194,362.742h9.548a1.194,1.194,0,0,0,1.194-1.194v-8.355A1.194,1.194,0,0,0,378.742,352h-9.548A1.194,1.194,0,0,0,368,353.194v8.355A1.194,1.194,0,0,0,369.194,362.742Zm1.194-8.355h7.161v5.968h-7.161Z",
    transform: "translate(-314.29 -300.678)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M369.194,122.742h9.548a1.194,1.194,0,0,0,1.194-1.194v-8.355A1.194,1.194,0,0,0,378.742,112h-9.548A1.194,1.194,0,0,0,368,113.194v8.355A1.194,1.194,0,0,0,369.194,122.742Zm1.194-8.355h7.161v5.968h-7.161Z",
    transform: "translate(-314.29 -96.484)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M273.194,122.742h9.548a1.194,1.194,0,0,0,1.194-1.194v-8.355A1.194,1.194,0,0,0,282.742,112h-9.548A1.194,1.194,0,0,0,272,113.194v8.355A1.194,1.194,0,0,0,273.194,122.742Zm1.194-8.355h7.161v5.968h-7.161Z",
    transform: "translate(-232.613 -96.484)",
    fill: "#0b5647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M321.194,404.774a1.194,1.194,0,0,0,1.194-1.194v-2.387a1.194,1.194,0,0,0-2.387,0v2.387A1.194,1.194,0,0,0,321.194,404.774Z",
    transform: "translate(-273.452 -341.517)",
    fill: "#15ac8e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVilla);
export default __webpack_public_path__ + "static/media/Villa.59bbae75b0b476b6777d4123da1d9428.svg";
export { ForwardRef as ReactComponent };